import React, { useState } from "react";
import { context, useAuth } from "../context/authContext";
import FormularioEntrada from "../components/formularios/FormularioTe1Express";

export default function Sidebar({
  showForm,
  setShowForm,
  showForm2,
  setShowForm2,
  showForm3,
  setShowForm3,
  showForm4,
  setShowForm4,
  showForm5,
  setShowForm5,
  showForm6,
  setShowForm6,
  showForm7,
  setShowForm7,
  showForm8,
  setShowForm8,
  showForm9,
  setShowForm9,
  showForm10,
  setShowForm10,
  showForm11,
  setShowForm11,
  showForm12,
  setShowForm12,
  showForm13,
  setShowForm13,
  showForm14,
  setShowForm14,
  showForm15,
  setShowForm15,
  showForm16,
  setShowForm16,
  showForm17,
  setShowForm17,
  showForm18,
  setShowForm18,
  showForm19,
  setShowForm19,
  showForm20,
  setShowForm20,
}) {
  const { user, logout, loading } = useAuth();
  const [menuServicios, setServicios] = useState(false);
  const [menuTusServicios, setTusServicios] = useState(false);
  const [menuPresupuestos, setPresupuestos] = useState(false);

  const handleItemClick = () => {
    if (
      !showForm2 &&
      !showForm3 &&
      !showForm4 &&
      !showForm5 &&
      !showForm6 &&
      !showForm7 &&
      !showForm8 &&
      !showForm9 &&
      !showForm10 &&
      !showForm11 &&
      !showForm12 &&
      !showForm13 &&
      !showForm14 &&
      !showForm15 &&
      !showForm16 &&
      !showForm17 &&
      !showForm18 &&
      !showForm19 &&
      !showForm20
    ) {
      setShowForm(!showForm);
      //setShowForm(true);
    }
  };

  const handleItemClick2 = () => {
    if (
      !showForm &&
      !showForm3 &&
      !showForm4 &&
      !showForm5 &&
      !showForm6 &&
      !showForm7 &&
      !showForm8 &&
      !showForm9 &&
      !showForm10 &&
      !showForm11 &&
      !showForm12 &&
      !showForm13 &&
      !showForm14 &&
      !showForm15 &&
      !showForm16 &&
      !showForm17 &&
      !showForm18 &&
      !showForm19 &&
      !showForm20
    ) {
      setShowForm2(!showForm2);
      //setShowForm2(true);
    }
    //setShowForm2(true);
  };

  const handleItemClick3 = () => {
    if (
      !showForm &&
      !showForm2 &&
      !showForm4 &&
      !showForm5 &&
      !showForm6 &&
      !showForm7 &&
      !showForm8 &&
      !showForm9 &&
      !showForm10 &&
      !showForm11 &&
      !showForm12 &&
      !showForm13 &&
      !showForm14 &&
      !showForm15 &&
      !showForm16 &&
      !showForm17 &&
      !showForm18 &&
      !showForm19 &&
      !showForm20
    ) {
      setShowForm3(!showForm3);
      //setShowForm3(true);
    }
  };

  const handleItemClick4 = () => {
    if (
      !showForm &&
      !showForm2 &&
      !showForm3 &&
      !showForm5 &&
      !showForm6 &&
      !showForm7 &&
      !showForm8 &&
      !showForm9 &&
      !showForm10 &&
      !showForm11 &&
      !showForm12 &&
      !showForm13 &&
      !showForm14 &&
      !showForm15 &&
      !showForm16 &&
      !showForm17 &&
      !showForm18 &&
      !showForm19 &&
      !showForm20
    ) {
      setShowForm4(!showForm4);
      //setShowForm3(true);
    }
  };

  const handleItemClick5 = () => {
    if (
      !showForm &&
      !showForm2 &&
      !showForm3 &&
      !showForm4 &&
      !showForm6 &&
      !showForm7 &&
      !showForm8 &&
      !showForm9 &&
      !showForm10 &&
      !showForm11 &&
      !showForm12 &&
      !showForm13 &&
      !showForm14 &&
      !showForm15 &&
      !showForm16 &&
      !showForm17 &&
      !showForm18 &&
      !showForm19 &&
      !showForm20
    ) {
      setShowForm5(!showForm5);
      //setShowForm3(true);
    }
  };

  const handleItemClick6 = () => {
    if (
      !showForm &&
      !showForm2 &&
      !showForm3 &&
      !showForm4 &&
      !showForm5 &&
      !showForm7 &&
      !showForm8 &&
      !showForm9 &&
      !showForm10 &&
      !showForm11 &&
      !showForm12 &&
      !showForm13 &&
      !showForm14 &&
      !showForm15 &&
      !showForm16 &&
      !showForm17 &&
      !showForm18 &&
      !showForm19 &&
      !showForm20
    ) {
      setShowForm6(!showForm6);
      //setShowForm3(true);
    }
  };

  const handleItemClick7 = () => {
    if (
      !showForm &&
      !showForm2 &&
      !showForm3 &&
      !showForm4 &&
      !showForm5 &&
      !showForm6 &&
      !showForm8 &&
      !showForm9 &&
      !showForm10 &&
      !showForm11 &&
      !showForm12 &&
      !showForm13 &&
      !showForm14 &&
      !showForm15 &&
      !showForm16 &&
      !showForm17 &&
      !showForm18 &&
      !showForm19 &&
      !showForm20
    ) {
      setShowForm7(!showForm7);
      //setShowForm3(true);
    }
  };

  const handleItemClick8 = () => {
    if (
      !showForm &&
      !showForm2 &&
      !showForm3 &&
      !showForm4 &&
      !showForm5 &&
      !showForm6 &&
      !showForm7 &&
      !showForm9 &&
      !showForm10 &&
      !showForm11 &&
      !showForm12 &&
      !showForm13 &&
      !showForm14 &&
      !showForm15 &&
      !showForm16 &&
      !showForm17 &&
      !showForm18 &&
      !showForm19 &&
      !showForm20
    ) {
      setShowForm8(!showForm8);
      //setShowForm3(true);
    }
  };

  const handleItemClick9 = () => {
    if (
      !showForm &&
      !showForm2 &&
      !showForm3 &&
      !showForm4 &&
      !showForm5 &&
      !showForm6 &&
      !showForm7 &&
      !showForm8 &&
      !showForm10 &&
      !showForm11 &&
      !showForm12 &&
      !showForm13 &&
      !showForm14 &&
      !showForm15 &&
      !showForm16 &&
      !showForm17 &&
      !showForm18 &&
      !showForm19 &&
      !showForm20
    ) {
      setShowForm9(!showForm9);
      //setShowForm3(true);
    }
  };

  const handleItemClick10 = () => {
    if (
      !showForm &&
      !showForm2 &&
      !showForm3 &&
      !showForm4 &&
      !showForm5 &&
      !showForm6 &&
      !showForm7 &&
      !showForm8 &&
      !showForm9 &&
      !showForm11 &&
      !showForm12 &&
      !showForm13 &&
      !showForm14 &&
      !showForm15 &&
      !showForm16 &&
      !showForm17 &&
      !showForm18 &&
      !showForm19 &&
      !showForm20
    ) {
      setShowForm10(!showForm10);
      //setShowForm3(true);
    }
  };

  const handleItemClick11 = () => {
    if (
      !showForm &&
      !showForm2 &&
      !showForm3 &&
      !showForm4 &&
      !showForm5 &&
      !showForm6 &&
      !showForm7 &&
      !showForm8 &&
      !showForm9 &&
      !showForm10 &&
      !showForm12 &&
      !showForm13 &&
      !showForm14 &&
      !showForm15 &&
      !showForm16 &&
      !showForm17 &&
      !showForm18 &&
      !showForm19 &&
      !showForm20
    ) {
      setShowForm11(!showForm11);
      //setShowForm3(true);
    }
  };

  const handleItemClick12 = () => {
    if (
      !showForm &&
      !showForm2 &&
      !showForm3 &&
      !showForm4 &&
      !showForm5 &&
      !showForm6 &&
      !showForm7 &&
      !showForm8 &&
      !showForm9 &&
      !showForm10 &&
      !showForm11 &&
      !showForm13 &&
      !showForm14 &&
      !showForm15 &&
      !showForm16 &&
      !showForm17 &&
      !showForm18 &&
      !showForm19 &&
      !showForm20
    ) {
      setShowForm12(!showForm12);
      //setShowForm3(true);
    }
  };

  const handleItemClick13 = () => {
    if (
      !showForm &&
      !showForm2 &&
      !showForm3 &&
      !showForm4 &&
      !showForm5 &&
      !showForm6 &&
      !showForm7 &&
      !showForm8 &&
      !showForm9 &&
      !showForm10 &&
      !showForm11 &&
      !showForm12 &&
      !showForm14 &&
      !showForm15 &&
      !showForm16 &&
      !showForm17 &&
      !showForm18 &&
      !showForm19 &&
      !showForm20
    ) {
      setShowForm13(!showForm13);
      //setShowForm3(true);
    }
  };

  const handleItemClick14 = () => {
    if (
      !showForm &&
      !showForm2 &&
      !showForm3 &&
      !showForm4 &&
      !showForm5 &&
      !showForm6 &&
      !showForm7 &&
      !showForm8 &&
      !showForm9 &&
      !showForm10 &&
      !showForm11 &&
      !showForm12 &&
      !showForm13 &&
      !showForm15 &&
      !showForm16 &&
      !showForm17 &&
      !showForm18 &&
      !showForm19 &&
      !showForm20
    ) {
      setShowForm14(!showForm14);
      //setShowForm3(true);
    }
  };

  const handleItemClick15 = () => {
    if (
      !showForm &&
      !showForm2 &&
      !showForm3 &&
      !showForm4 &&
      !showForm5 &&
      !showForm6 &&
      !showForm7 &&
      !showForm8 &&
      !showForm9 &&
      !showForm10 &&
      !showForm11 &&
      !showForm12 &&
      !showForm13 &&
      !showForm14 &&
      !showForm16 &&
      !showForm17 &&
      !showForm18 &&
      !showForm19 &&
      !showForm20
    ) {
      setShowForm15(!showForm15);
      //setShowForm3(true);
    }
  };

  const handleItemClick16 = () => {
    if (
      !showForm &&
      !showForm2 &&
      !showForm3 &&
      !showForm4 &&
      !showForm5 &&
      !showForm6 &&
      !showForm7 &&
      !showForm8 &&
      !showForm9 &&
      !showForm10 &&
      !showForm11 &&
      !showForm12 &&
      !showForm13 &&
      !showForm14 &&
      !showForm15 &&
      !showForm17 &&
      !showForm18 &&
      !showForm19 &&
      !showForm20
    ) {
      setShowForm16(!showForm16);
      //setShowForm3(true);
    }
  };

  const handleItemClick17 = () => {
    if (
      !showForm &&
      !showForm2 &&
      !showForm3 &&
      !showForm4 &&
      !showForm5 &&
      !showForm6 &&
      !showForm7 &&
      !showForm8 &&
      !showForm9 &&
      !showForm10 &&
      !showForm11 &&
      !showForm12 &&
      !showForm13 &&
      !showForm14 &&
      !showForm15 &&
      !showForm16 &&
      !showForm18 &&
      !showForm19 &&
      !showForm20
    ) {
      setShowForm17(!showForm17);
      //setShowForm3(true);
    }
  };

  const handleItemClick18 = () => {
    if (
      !showForm &&
      !showForm2 &&
      !showForm3 &&
      !showForm4 &&
      !showForm5 &&
      !showForm6 &&
      !showForm7 &&
      !showForm8 &&
      !showForm9 &&
      !showForm10 &&
      !showForm11 &&
      !showForm12 &&
      !showForm13 &&
      !showForm14 &&
      !showForm15 &&
      !showForm16 &&
      !showForm17 &&
      !showForm19 &&
      !showForm20
    ) {
      setShowForm18(!showForm18);
      //setShowForm3(true);
    }
  };

  const handleItemClick19 = () => {
    if (
      !showForm &&
      !showForm2 &&
      !showForm3 &&
      !showForm4 &&
      !showForm5 &&
      !showForm6 &&
      !showForm7 &&
      !showForm8 &&
      !showForm9 &&
      !showForm10 &&
      !showForm11 &&
      !showForm12 &&
      !showForm13 &&
      !showForm14 &&
      !showForm15 &&
      !showForm16 &&
      !showForm17 &&
      !showForm18 &&
      !showForm20
    ) {
      setShowForm19(!showForm19);
      //setShowForm3(true);
    }
  };

  const handleItemClick20 = () => {
    if (
      !showForm &&
      !showForm2 &&
      !showForm3 &&
      !showForm4 &&
      !showForm5 &&
      !showForm6 &&
      !showForm7 &&
      !showForm8 &&
      !showForm9 &&
      !showForm10 &&
      !showForm11 &&
      !showForm12 &&
      !showForm13 &&
      !showForm14 &&
      !showForm15 &&
      !showForm16 &&
      !showForm17 &&
      !showForm18 &&
      !showForm19
    ) {
      setShowForm20(!showForm20);
      //setShowForm3(true);
    }
  };

  return (
    <div>
      {/* Agregar el enlace al archivo de la biblioteca FontAwesome */}
      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css"
        rel="stylesheet"
      />

      {/* Navegación lateral */}
      <aside className="bg-gray-800 text-white w-64 min-h-screen p-4">
        <nav>
          <ul className="space-y-2">
            <li className={"opcion-con-desplegable"}>
              <div
                className="flex items-center justify-between p-2 hover:bg-gray-700"
                onClick={() => setServicios(!menuServicios)}
              >
                <div className="flex items-center">
                  <i className="fas fa-calendar-alt mr-2" />
                  <span>Servicios</span>
                </div>
                <i
                  className={`fas fa-chevron-down text-xs ${
                    menuServicios ? "rotate-180" : ""
                  }`}
                />
              </div>
              <ul
                className={`desplegable ml-4 ${
                  menuServicios ? "block" : "hidden"
                }`}
              >
                <li>
                  <a
                    href="#"
                    className="block p-2 hover:bg-gray-700 flex items-center"
                    onClick={handleItemClick}
                  >
                    <i className="fas fa-chevron-right mr-2 text-xs" />
                    TE1 Express
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="block p-2 hover:bg-gray-700 flex items-center"
                    onClick={handleItemClick2}
                  >
                    <i className="fas fa-chevron-right mr-2 text-xs" />
                    TE1 Convencional
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="block p-2 hover:bg-gray-700 flex items-center"
                    onClick={handleItemClick3}
                  >
                    <i className="fas fa-chevron-right mr-2 text-xs" />
                    Modelos y memorias lumínicas (TE2)
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="block p-2 hover:bg-gray-700 flex items-center"
                    onClick={handleItemClick4}
                  >
                    <i className="fas fa-chevron-right mr-2 text-xs" />
                    Cálculos y cubicaciones
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="block p-2 hover:bg-gray-700 flex items-center"
                    onClick={handleItemClick5}
                  >
                    <i className="fas fa-chevron-right mr-2 text-xs" />
                    Modelos BIM
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="block p-2 hover:bg-gray-700 flex items-center"
                    onClick={handleItemClick6}
                  >
                    <i className="fas fa-chevron-right mr-2 text-xs" />
                    Otros
                  </a>
                </li>
              </ul>
            </li>
            <li className={"opcion-con-desplegable"}>
              <div
                className="flex items-center justify-between p-2 hover:bg-gray-700"
                onClick={() => setTusServicios(!menuTusServicios)}
              >
                <div className="flex items-center">
                  <i className="fas fa-calendar-alt mr-2" />
                  <span>Tus proyectos</span>
                </div>
                <i
                  className={`fas fa-chevron-down text-xs ${
                    menuTusServicios ? "rotate-180" : ""
                  }`}
                />
              </div>
              <ul
                className={`desplegable ml-4 ${
                  menuTusServicios ? "block" : "hidden"
                }`}
              >
                <li>
                  <a
                    href="#"
                    className="block p-2 hover:bg-gray-700 flex items-center"
                    onClick={handleItemClick7}
                  >
                    <i className="fas fa-chevron-right mr-2 text-xs" />
                    TE1 Express
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="block p-2 hover:bg-gray-700 flex items-center"
                    onClick={handleItemClick8}
                  >
                    <i className="fas fa-chevron-right mr-2 text-xs" />
                    TE1 Convencional
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="block p-2 hover:bg-gray-700 flex items-center"
                    onClick={handleItemClick9}
                  >
                    <i className="fas fa-chevron-right mr-2 text-xs" />
                    Modelos y memorias lumínicas (TE2)
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="block p-2 hover:bg-gray-700 flex items-center"
                    onClick={handleItemClick10}
                  >
                    <i className="fas fa-chevron-right mr-2 text-xs" />
                    Cálculos y cubicaciones
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="block p-2 hover:bg-gray-700 flex items-center"
                    onClick={handleItemClick11}
                  >
                    <i className="fas fa-chevron-right mr-2 text-xs" />
                    Modelos BIM
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="block p-2 hover:bg-gray-700 flex items-center"
                    onClick={handleItemClick12}
                  >
                    <i className="fas fa-chevron-right mr-2 text-xs" />
                    Otros
                  </a>
                </li>
              </ul>
            </li>
            <li className={"opcion-con-desplegable"}>
              <div
                className="flex items-center justify-between p-2 hover:bg-gray-700"
                onClick={() => setPresupuestos(!menuPresupuestos)}
              >
                <div className="flex items-center">
                  <i className="fas fa-calendar-alt mr-2" />
                  <span>Presupuestos</span>
                </div>
                <i
                  className={`fas fa-chevron-down text-xs ${
                    menuPresupuestos ? "rotate-180" : ""
                  }`}
                />
              </div>
              <ul
                className={`desplegable ml-4 ${
                  menuPresupuestos ? "block" : "hidden"
                }`}
              >
                <li>
                  <a
                    href="#"
                    className="block p-2 hover:bg-gray-700 flex items-center"
                    onClick={handleItemClick13}
                  >
                    <i className="fas fa-chevron-right mr-2 text-xs" />
                    TE1 Express
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="block p-2 hover:bg-gray-700 flex items-center"
                    onClick={handleItemClick14}
                  >
                    <i className="fas fa-chevron-right mr-2 text-xs" />
                    TE1 Convencional
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="block p-2 hover:bg-gray-700 flex items-center"
                    onClick={handleItemClick15}
                  >
                    <i className="fas fa-chevron-right mr-2 text-xs" />
                    Modelos y memorias lumínicas (TE2)
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="block p-2 hover:bg-gray-700 flex items-center"
                    onClick={handleItemClick16}
                  >
                    <i className="fas fa-chevron-right mr-2 text-xs" />
                    Cálculos y cubicaciones
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="block p-2 hover:bg-gray-700 flex items-center"
                    onClick={handleItemClick17}
                  >
                    <i className="fas fa-chevron-right mr-2 text-xs" />
                    Modelos BIM
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="block p-2 hover:bg-gray-700 flex items-center"
                    onClick={handleItemClick18}
                  >
                    <i className="fas fa-chevron-right mr-2 text-xs" />
                    Otros
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="block p-2 hover:bg-gray-700 flex items-center"
                    onClick={handleItemClick19}
                  >
                    <i className="fas fa-chevron-right mr-2 text-xs" />
                    Tus Presupuestos
                  </a>
                </li>
              </ul>
            </li>

            <div>
              <a
                href="#"
                className="block p-2 hover:bg-gray-700 flex items-center"
                onClick={handleItemClick20}
              >
                <i className="fas fa-chevron-right mr-2 text-xs" />
                Beneficios
              </a>
            </div>
            {/* Agrega más enlaces para la navegación lateral */}
          </ul>
        </nav>
      </aside>
      {/* Contenido principal */}
      <main className="container mx-auto p-4">
        {/* Aquí puedes agregar el contenido principal de tu página CRM */}
      </main>
    </div>
  );
}
